/**
 * @file Pinia store for the current organization's settings.
 * @description
 * Passerelle fine vers `OrganizationsService` (canon 2 couches) : les écrans
 * qui lisent/modifient l'organisation (démo, onboarding, réglages légaux,
 * branding email, avis Google) gardent leur propre état ; ce store se contente
 * de router l'accès données, en propageant valeurs et exceptions telles quelles.
 */

import { defineStore } from "pinia";
import OrganizationsService from "@/services/organizations.service";

export const useOrganizationsStore = defineStore("organizations", () => {
  const getMyOrganization = () => OrganizationsService.getMyOrganization();

  const updateOrganization = (
    ...args: Parameters<typeof OrganizationsService.updateOrganization>
  ) => OrganizationsService.updateOrganization(...args);

  const updateOrganizationLegal = (
    ...args: Parameters<typeof OrganizationsService.updateOrganizationLegal>
  ) => OrganizationsService.updateOrganizationLegal(...args);

  const getEmailBranding = () => OrganizationsService.getEmailBranding();

  const updateEmailBranding = (
    ...args: Parameters<typeof OrganizationsService.updateEmailBranding>
  ) => OrganizationsService.updateEmailBranding(...args);

  const getGoogleReviewSettings = () =>
    OrganizationsService.getGoogleReviewSettings();

  const getGoogleReviewStatistics = (
    ...args: Parameters<typeof OrganizationsService.getGoogleReviewStatistics>
  ) => OrganizationsService.getGoogleReviewStatistics(...args);

  const updateGoogleReviewSettings = (
    ...args: Parameters<typeof OrganizationsService.updateGoogleReviewSettings>
  ) => OrganizationsService.updateGoogleReviewSettings(...args);

  const processPendingGoogleReviewRequests = () =>
    OrganizationsService.processPendingGoogleReviewRequests();

  return {
    getMyOrganization,
    updateOrganization,
    updateOrganizationLegal,
    getEmailBranding,
    updateEmailBranding,
    getGoogleReviewSettings,
    getGoogleReviewStatistics,
    updateGoogleReviewSettings,
    processPendingGoogleReviewRequests,
  };
});
